import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../assets/styles/SareesPage.css";
import { BaseUrl } from "../config/api";
import defaultSareeImage from "../assets/images/saree-category.png";
import { toHttps } from "../utils/imageUtils";

const SareeCategory = () => {
  const [sareeCategories, setSareeCategories] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        // Fetch categories
        const categoryResponse = await fetch(`${BaseUrl}/categories/allcategory`);
        if (!categoryResponse.ok) {
          console.error("Failed to fetch categories:", categoryResponse.status);
          return;
        }
        const categoryData = await categoryResponse.json();

        // Fetch all products
        const productsResponse = await fetch(`${BaseUrl}/products/getallproducts`);
        if (!productsResponse.ok) {
          console.error("Failed to fetch products:", productsResponse.status);
          return;
        }
        const productsData = await productsResponse.json();
        console.log("pr", productsData);

        // Validate that we received arrays
        if (!Array.isArray(categoryData) || !Array.isArray(productsData)) {
          console.error("Invalid data format received");
          return;
        }

        // Filter and map categories, including only those with available products
        const filteredCategories = categoryData
          .filter((category) => {
            if (category.categoryTypeName?.toLowerCase() !== "saree" || category.isDeleted) {
              return false;
            }

            const availableProductsCount = productsData.filter(product =>
              !product.isDeleted &&
              product.categoryName === category.categoryName &&
              product.stock > 0 &&
              !product.outOfStock
            ).length;

            return availableProductsCount > 0;
          })
          .map((category) => ({
            name: category.categoryName,
            image: toHttps(category.categotyImage) || BaseUrl + category.categotyImage || defaultSareeImage,
            path: category.categoryName.toLowerCase().replace(/\s+/g, "-"),
          }));

        setSareeCategories(filteredCategories);
      } catch (error) {
        console.error("Error fetching saree categories:", error);
      }
    };

    fetchCategories();
  }, []);

  return (
    <>
      {sareeCategories.length > 0 && (
        <div className="sarees-categories-section">
          <h2 className="sarees-section-title">Sarees</h2>
          <div className="sarees-category-cards">
            {sareeCategories.map((category, index) => (
              <Link
                to={`/category/${category.path}`}
                key={index}
                className="saree-card-link"
              >
                <div className="saree-card">
                  <img
                    src={category.image}
                    alt={category.name}
                    onError={(e) => {
                      e.target.src = defaultSareeImage;
                    }}
                  />
                  <div className="saree-card-overlay">
                    <h3>{category.name}</h3>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default SareeCategory;
